export default "__VITE_ASSET__DSVpabbx__"